import { render, staticRenderFns } from "./members.vue?vue&type=template&id=54255ad1&scoped=true&"
import script from "./members.vue?vue&type=script&lang=js&"
export * from "./members.vue?vue&type=script&lang=js&"
import style0 from "./members.vue?vue&type=style&index=0&id=54255ad1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54255ad1",
  null
  
)

export default component.exports